import { RunwayWindSpeedSettings } from '@mono/types/src/runway-widgets';

export const defaultRunwayWindSpeedSettings: RunwayWindSpeedSettings = {
    title: 'Wind Speed (Knots)',
    aerodrome: 'NZWN',
    mode: 'cozy',
    weatherStations: [
        {
            sensor: 'NZWNW',
            name: 'SP',
        },
        {
            sensor: 'NZWNM',
            name: 'S13',
        },
        {
            sensor: 'NZWNN',
            name: 'S15',
        },
        {
            sensor: 'NZWNO',
            name: 'S16',
        },
        {
            sensor: 'NZWNP',
            name: 'S23',
        },
        {
            sensor: 'NZWNQ',
            name: 'S26',
        },
    ],
    thresholds: [
        { key: 0, colour: '#FA6161', value: 30 },
        { key: 1, colour: '#FF981B', value: 20 },
    ],
    defaultColour: '#74A30F',
};
